import React, { useEffect, useRef } from "react";
import "../../css/UserMention.css";

function UserMentionDropdown({
  isOpen,
  query,
  results,
  loading,
  position,
  highlightIndex,
  onSelect,
  onClose,
}) {
  const dropdownRef = useRef(null);
  const highlightedRef = useRef(null);

  useEffect(() => {
    if (highlightedRef.current) {
      highlightedRef.current.scrollIntoView({ block: "nearest" });
    }
  }, [highlightIndex]);

  useEffect(() => {
    if (!isOpen) return;
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      ref={dropdownRef}
      className="UserMention__dropdown"
      style={{
        position: "fixed",
        top: `${position.top}px`,
        left: `${position.left}px`,
        zIndex: 99999,
      }}
    >
      <div className="UserMention__dropdown-header">
        <i className="fas fa-at"></i>
        <span>Mention a person</span>
        {query && <span className="UserMention__dropdown-query">@{query}</span>}
      </div>

      {loading && results.length === 0 && (
        <div className="UserMention__dropdown-loading">Searching...</div>
      )}

      {!loading && query.length >= 1 && results.length === 0 && (
        <div className="UserMention__dropdown-empty">No people found</div>
      )}

      {!loading && query.length === 0 && results.length === 0 && (
        <div className="UserMention__dropdown-hint">
          Type a name or email to mention someone
        </div>
      )}

      {results.length > 0 && (
        <div className="UserMention__dropdown-results">
          {results.map((user, idx) => (
            <div
              key={user.uid || user.email}
              ref={idx === highlightIndex ? highlightedRef : null}
              className={`UserMention__dropdown-item ${
                idx === highlightIndex ? "UserMention__dropdown-item--active" : ""
              }`}
              onMouseDown={(e) => {
                e.preventDefault();
                onSelect(user);
              }}
            >
              <div className="UserMention__dropdown-item-avatar">
                {(user.name || user.email || "?")[0].toUpperCase()}
              </div>
              <div className="UserMention__dropdown-item-info">
                {user.name && (
                  <span className="UserMention__dropdown-item-name">{user.name}</span>
                )}
                <span className="UserMention__dropdown-item-email">{user.email}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default UserMentionDropdown;
